import React from 'react';
import { connect } from 'react-redux';

import { hidePlatformInfo as hidePlatformInfoAction } from '../../actions';
import { TitleContainer, TitleIcon, TitleText } from '../details';
import IconButton from '@mui/material/IconButton';

const PlatformInfoTitle = ({ hidePlatformInfo }) => {
    return (
        <TitleContainer>
            <IconButton
                onClick={e => {
                    e.stopPropagation();
                    hidePlatformInfo();
                }}
            >
                <TitleIcon iconClassName="material-icons-outlined">arrow_back</TitleIcon>
            </IconButton>
            <TitleText>About this platform</TitleText>
            <TitleIcon hidden />
        </TitleContainer>
    );
};

export default connect(null, {
    hidePlatformInfo: hidePlatformInfoAction,
})(PlatformInfoTitle);
